
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import ReligionTable from '../components/ReligionTable';

const Religion = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/religion/add');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Religion Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Religion
        </button>
      </div>

      <ReligionTable />
    </div>
  );
};

export default Religion;